import { render, staticRenderFns } from "./wellness.vue?vue&type=template&id=5c005db4&scoped=true"
import script from "./wellness.vue?vue&type=script&lang=ts"
export * from "./wellness.vue?vue&type=script&lang=ts"
import style0 from "./wellness.vue?vue&type=style&index=0&id=5c005db4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c005db4",
  null
  
)

export default component.exports